import { render, staticRenderFns } from "./globalAllergens.vue?vue&type=template&id=6ae05346&scoped=true&xmlns%3Atemplate=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./globalAllergens.vue?vue&type=script&lang=js&"
export * from "./globalAllergens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae05346",
  null
  
)

export default component.exports